<template>
	<div style="height: 100%; width: 100%" class="ma-0 pa-0 content-pad-vert">
		<v-layout row wrap>
			<div class="nav-container">
				<div class="parallelogramlogo">
					<div class="unskew">
						<div class="d-inline-block">
							<img style="cursor: pointer" @click="saveAndExit" src="/static/images/navbar/logo-color.svg" height="35" alt="WRKPRTY" />
						</div>
					</div>
				</div>
				<div class="d-inline-block pa-3" style="float: right">
					<h4>
						<v-btn @click="help" flat small class="pa-1" style="min-width: auto">Help</v-btn>|<v-btn @click="saveAndExit" flat small class="pa-1">Save &amp; Exit</v-btn>
					</h4>
				</div>
			</div>
		</v-layout>
		<v-layout row wrap align-center class="mt-5">
			<v-flex xs12 sm6 md5 offset-md2 v-if="applied == false" class="pl-3 pr-3">
				<p class="host-info-header-1-dark mb-3">
					Voila!
				</p>
				<div class="mb-4">This is gonna be great. <span class="host-info-bold">ONE last question:</span></div>
				<div style="font-size: 1.25em; color: #666666; font-weight: 400;">What’s one (or two) of the BILLIONS of reasons <span style="font-weight: 700;">you have what it takes</span> to be a stellar WRKPRTY host?</div>
				<v-textarea v-model="description" label=""></v-textarea>

				<v-btn raised dark block class="btn-min-height blue lighten-2 mt-5 btn-large elevation-2" @click="apply">
					Submit
				</v-btn>
			</v-flex>
			<v-flex xs12 v-else>
				<v-card flat style="position: absolute; top: 0px; left: 0px; width: 100%; margin-bottom: 0px;">
					<v-img src="/static/images/background-2.jpg" height="100vh" class="host-info-background-image">
						<v-layout row wrap align-center>
							<v-flex xs12 md6 offset-md3 class="pa-3">
								<p class="host-info-header-1 mb-4">Thanks for applying!</p>
								<p class="host-info-sub-header-1 mb-3">We're excited to welcome you as part of the Wrkprty team.</p>
								<p class="host-info-sub-header-1 mb-3">Once we review your host application we will reach out to you with more information about hosting Wrkprtys.</p>
								<v-btn to="/">Homepage</v-btn>
							</v-flex>
						</v-layout>
					</v-img>
				</v-card>
			</v-flex>
			<v-flex lg3 md4 sm6 hidden-xs-only style="padding: 0px 30px 0px 30px;" v-if="applied == false">
				<v-card raised>
					<v-card-text>
						<v-icon class="mb-2 host-apply-tip-icon">fa-info-circle</v-icon>
						<p>Example:</p>
						<strong>“I like meeting people and making sure they feel welcome in new groups... I’m also  famous for my delicious pour-over coffee and I can probably pull off leading a group through 4 really easy yoga poses.”</strong>
						<br><br>
						<p>Keep it simple, Rockstar. We just want to help you shine on. :)</p>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
	data() {
		return {
			applied: false
		}
	},
	created() {
		this.setlastHostApplyStep(this.$route.name)
	},
	methods: {
		...mapActions([
			'setlastHostApplyStep',
			'setHostApplyInfo',
			'serverPutHostApplication'
		]),
		help() {
			alert('Help!')
		},
		saveAndExit() {
			this.$router.push({ name: 'host_dashboard' })
		},
		apply() {
			this.serverPutHostApplication(this.getHost.uuid).then(response => {
				this.applied = true
			})
		}
	},
	computed: {
		...mapGetters(['getHost', 'getHostApplyInfo']),
		description: {
			get() {
				return this.getHostApplyInfo('description')
			},
			set(val) {
				this.setHostApplyInfo({
					prop: 'description',
					value: val
				})
			}
		}
	}
}
</script>
